import * as z from "zod";
import { numericOptionSchema } from "../common/option-schema";
import { requiredErrorMessage } from "../common/error-messages";
import { requiredNumberSchema } from "../common/required-number-schema";

export const addServiceSchemaSchema = z.object({
  category: z.object(numericOptionSchema, { error: requiredErrorMessage }),
  name: z
    .string()
    .min(1, requiredErrorMessage)
    .max(100, "Name must be at most 100 characters.")
    .refine(
      (val) => val.length === 0 || /^[a-zA-Z0-9/\s\-_.&()']+$/.test(val),
      "Name can only contain letters, numbers, spaces, forward slashes, hyphens, underscores, periods, ampersands, parentheses, and apostrophes."
    ),
  description: z
    .string()
    .max(256, "Description must be at most 256 characters."),
  staff_level: z.string(),
  duration: z.number(),
  price: requiredNumberSchema(
    z
      .number()
      .min(0, { message: "Price must be at least 0." })
      .max(9999999999, { message: "Price must be at most 9,999,999,999." })
      .multipleOf(0.01, { message: "Price can be up to 2 decimal places." })
  ),
});
